import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { DiscoveryCardContentSize, DiscoveryContainerType, DiscoveryOfferingType, DiscoveryRecommendationInputContext, DiscoveryRecommendationStrategy, LineOfBusinessDomain, RecommendationsModule } from '@shared-ui/retail-recommendation-module';
import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { getShoppingContextInput } from 'src/common/stores/adapters';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';
import CarouselContext from 'src/common/stores/contexts/carousel-context-provider';
import { ConfigurationIdentifiers } from 'src/common/constants/configuration-identifiers';
import { EgRecsPlacementIds } from 'src/common/constants/eg-recs-placements';
import { DiscoveryPriceStrategy } from 'src/common/__generated__/api';
import { SimpleLazyLoadWrapper } from '../../common/lazy/simple-lazy-load-wrapper';
export const RecommendationsModuleWrapper = inject('currentHotel', 'multiItem')(observer(props => {
  var _a, _b, _c, _d, _e, _f;
  const {
    addTopCarouselName
  } = React.useContext(CarouselContext);
  React.useEffect(() => addTopCarouselName('similar-properties'), []);
  const context = usePlatformContext();
  const searchCriteria = useSearchCriteriaContext();
  const multiItemContext = (_a = props.multiItem) === null || _a === void 0 ? void 0 : _a.multiItemContext;
  const shoppingContext = getShoppingContextInput(multiItemContext);
  const propertySearchCriteria = adaptSearchCriteria(context, searchCriteria);
  const inputProps = {
    inputs: {
      propertyId: String((_b = props.currentHotel) === null || _b === void 0 ? void 0 : _b.hotelId),
      searchCriteria: propertySearchCriteria,
      shoppingContext
    }
  };
  const {
    checkInDate,
    checkOutDate
  } = (_e = (_d = (_c = inputProps.inputs) === null || _c === void 0 ? void 0 : _c.searchCriteria) === null || _d === void 0 ? void 0 : _d.primary.dateRange) !== null && _e !== void 0 ? _e : {};
  if (!checkInDate || !checkOutDate) {
    return null;
  }
  const {
    showFeaturedHeader
  } = props;
  return React.createElement(SimpleLazyLoadWrapper, null, React.createElement(RecommendationsModule, {
    inputs: {
      configurationIdentifier: showFeaturedHeader ? ConfigurationIdentifiers.LODGING_DATED_PDP_CAROUSEL_FEATURED_HEADER_CHECK : ConfigurationIdentifiers.LODGING_DATED_PDP_CAROUSEL_NO_FEATURED_HEADER_CHECK,
      contentSize: DiscoveryCardContentSize.LONG_FORM_FEATURED,
      offeringType: DiscoveryOfferingType.PRODUCT,
      strategy: DiscoveryRecommendationStrategy.ALTERNATIVE,
      containerType: DiscoveryContainerType.CAROUSEL,
      priceStrategy: DiscoveryPriceStrategy.LIVE,
      input: [DiscoveryRecommendationInputContext.PRODUCT],
      recommendationContext: {
        outputLineOfBusiness: LineOfBusinessDomain.LODGING,
        pageId: 'HIS',
        lodging: {
          propertyId: String((_f = inputProps === null || inputProps === void 0 ? void 0 : inputProps.inputs) === null || _f === void 0 ? void 0 : _f.propertyId),
          checkin: checkInDate,
          checkout: checkOutDate
        }
      },
      placementId: EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID
    }
  }));
}));
export const SharedUiRecommendationsModuleWrapper = RecommendationsModuleWrapper;
SharedUiRecommendationsModuleWrapper.displayName = 'SharedUiRecommendationsModuleWrapper';